<template>
  <div class="card-sty">
    <v-card
      class="card-shadow"
      id="gauge-card"
      :width="thermoProp.card_maxwidth"
      :height="thermoProp.card_maxheight"
    >

  <div class=" text-center text-sm-subtitle-1">{{this.thermoProp.component_name}}</div>
      <v-card-text >
        <div>

   <vue-thermometer 
      :value="thermoProp.series"
      :min="thermoProp.minValue"
      :max="thermoProp.maxValue"
      class="thero_style"
      :options='options'
    />
</div>
        <div >

        <h5 style="font-size: small; font-weight: bold; 
        text-align: center">
          {{ thermoProp.originalValue }} &#8451;
        </h5>
</div>

        <h6 style="font-size: -small; margin-top: 0px;text-align: center">{{
          thermoProp.timestamp}}</h6>
        
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import VueApexCharts from "vue-apexcharts";
export default {
  name: "thermometer",
  props: ["thermoProp"],
  components: {
    // apexchart: VueApexCharts,
  },
  data: function () {
    return {
        options: {
  text: {
    color: this.thermoProp.text_color,
    fontSize: this.thermoProp.fontSize,
    textAdjustmentY: this.thermoProp.textAdjustmentY,
    fontFamily: this.thermoProp.textfontFamily,
    textEnabled: this.thermoProp.show_widget_text,
    marginLeft: this.thermoProp.marginLeft,
     fontWeight: this.thermoProp.fontWeight,
  },
  thermo: {
    color: this.thermoProp.widget_foreground_color,
    backgroundColor: this.thermoProp.widget_background_color,
    frameColor: this.thermoProp.widget_border_color,
    ticks: this.thermoProp.ticks,
    
    ticksEnabled: this.thermoProp.ticksEnabled,
    tickColor: this.thermoProp.tickColor,
    tickWidth: this.thermoProp.tickWidth
  },
  layout: {
    height: this.thermoProp.widget_height,
    width: this.thermoProp.widget_width,
    
  }
},

    };
  },
};
</script>

<style scoped>
@media  only screen and  (max-width: 1280px){
.card-sty{
text-align: center;
margin: 0px 5px 5px 5px

}
}
@media  only screen and (min-width: 1281px) and  (max-width: 1366px){
.card-sty{
text-align: center;
margin: 0px 10px 5px 10px

}
}
@media  only screen and (min-width: 1367px) and (max-width: 1440px){
.card-sty{
text-align: center;
margin: 0px 10px 5px 10px

}
}
@media  only screen and (min-width: 2560px) and (max-width: 2560px){
.card-sty{
text-align: center;
margin: 0px 10px 5px 10px

}
}
@media  only screen and (min-width: 1921px) and (max-width: 2559px){
.card-sty{
text-align: center;
margin: 0px 10px 5px 10px

}
.chartClass1{
  margin-left: 15px;
}
}
@media  only screen and (min-width: 1441px) and (max-width: 1920px){
.insigDim{
  margin-right: -85px;
  margin-left: -80px;
}

}
#gauge-card {
  /* border-style: solid ;
  border-radius: 15px;
    border-color: #a7a7a7; */
}
.item2 {
  font-family: "EMPrint";
  font-size: 16px;
  font-weight: bold;
}
.minClass{

            font-size: small;
            font-weight: bolder;
            text-align: center;
            margin: -20px 50px -5px -60px;
          
}
.minClass1{
              font-size: small;
            font-weight: bolder;
            text-align: center;
            margin: -20px 140px -5px -60px;

}
.maxClass{
    font-size: small;
            font-weight: bolder;
            text-align: center;
            margin: -22px -200px 0px -80px;
}
.maxClass1{
    font-size: small;
            font-weight: bolder;
            text-align: center;
            margin: -22px -300px 0px -80px;

}
.thero_style
{
margin-left:35px;
margin-top:-20px;
 margin-bottom: -15px;

}
</style>